import { PromotionActivityStatus } from "@interfaces/IPromotionActivity";

export const chooseStatusColor = (status: PromotionActivityStatus) => {
    const { ACTIVE, PLANNED, ENDED } = PromotionActivityStatus;
    switch (status) {
        case ACTIVE:
            return 'blue';
        case PLANNED:
            return 'orange';
        case ENDED:
            return 'success';
        default:
            return 'error';
    }
}

export const chooseStatusText = (status: PromotionActivityStatus, content: Record<string, string>) => {
    const { ACTIVE, PLANNED, ENDED } = PromotionActivityStatus;
    const { status_active, status_planned, status_ended, status_error } = content;

    switch (status) {
        case ACTIVE:
            return status_active;
        case PLANNED:
            return status_planned;
        case ENDED:
            return status_ended;
        default:
            return status_error;
    }
}

export const allowEdit = (status: PromotionActivityStatus) => {
    const { PLANNED, ERROR } = PromotionActivityStatus;
    return status === PLANNED || status === ERROR;
}

export const promotionActivityIsActive = (status: PromotionActivityStatus) => {
    return status === PromotionActivityStatus.ACTIVE;
}
